<td><strong>{{ fileView.name }}</strong></td>
<td class="w-10">{{ fileView.size/1024/1024 | number:'.2' }} MB</td>
<td class="w-20">
    <div class="progress" style="margin-bottom: 0;">
        <mat-progress-bar *ngIf="fileView.progress" [value]="fileView.progress" class="progress-bar"
                          mode="determinate" progressbarId="fileView.id">
        </mat-progress-bar>
    </div>
</td>
<td class="w-20">
    <span>{{fileView.status}}</span>
</td>
<td class="w-10">
    <div #buttons class="file-action-buttons">
        <button (click)="rowClicked(typeButton.UPLOAD)" [disabled]="disableAllButtonsRow || fileView.disableAllButtons || fileView.disableUploadButton" class="btn btn-primary btn-xs"
                type="button">
            <span class="glyphicon glyphicon-upload"></span>
        </button>
        <button (click)="rowClicked(typeButton.DELETE)" [disabled]="disableAllButtonsRow || fileView.disableAllButtons" class="btn btn-primary btn-xs"
                type="button">
            <span class="glyphicon glyphicon-trash"></span>
        </button>
    </div>
</td>
